import {useEffect, useState} from "react";
import api from "../../interceptor/interceptor";
import Placeholder from "../placeholder/placeholder";

const Video = (
    {
        tripId = '',
        videoId = '',
        alertData = {},
        controls = false,
        autoPlay = false,
        isThumb = false,
        videoLink = '',
        onClick = (val, index, videoData) => {},
        onLoaded = (data) => {}
    }
) => {

    const [videoData, setVideoData] = useState(null);
    const [videoLoader, setVideoLoader] = useState(false);


    const getVideo = async () => {
        setVideoLoader(true);
        if (tripId && videoId) {
            try {
                const response = await api.get(`/alerts/dvr/${videoId}/trips/${tripId}`);
                setVideoData(response.data);
                onLoaded(response.data);
            } catch (e) {
                console.log(e);
            }
        }
        setVideoLoader(false);
    }

    useEffect(() => {
        getVideo()
    }, [videoId]);

    return (
        <>
            {!isThumb && !videoLoader &&
                <video className={'video-box width-block-100 black-back'}
                       height={'100%'}
                       src={videoData?.videoLink}
                       controls={controls}
                       autoPlay={autoPlay}
                       muted onClick={event => onClick(true, videoData, alertData)}>
                    {!videoLink && <source src={videoData?.videoLink} type="video/mp4"/>}
                    {videoLink && <source src={videoLink} type="video/mp4"/>}
                </video>
            }

            {isThumb && !videoLoader &&
                <video className={'video-box width-block-100 black-back'}
                       height={'100%'}
                       src={videoLink}>
                </video>
            }
            {videoLoader &&
                <Placeholder height={'100%'}/>
            }
        </>
    )

}

export default Video;
